// Function codes for students are:
export const STUDENT_FUNCTION_CODES = ['1050', '4350', '9060']
